<script lang="ts">
	import { _ } from 'svelte-i18n';

	const groups = [
		{
			id: 'work',
			features: [
				{
					id: 'todos',
					icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4'
				},
				{
					id: 'tasks',
					icon: 'M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2'
				},
				{
					id: 'projects',
					icon: 'M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z'
				},
				{
					id: 'clients',
					icon: 'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
				}
			]
		},
		{
			id: 'docs',
			features: [
				{
					id: 'notes',
					icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'
				},
				{
					id: 'files',
					icon: 'M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4'
				}
			]
		},
		{
			id: 'team',
			features: [
				{ id: 'pulse', icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
				{
					id: 'messages',
					icon: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z'
				},
				{
					id: 'people',
					icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z'
				},
				{
					id: 'absence',
					icon: 'M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z'
				},
				{
					id: 'calendar',
					icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z'
				}
			]
		},
		{
			id: 'business',
			features: [
				{ id: 'timeTracking', icon: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z' },
				{
					id: 'invoicing',
					icon: 'M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z'
				},
				{
					id: 'cashflow',
					icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z'
				},
				{
					id: 'reports',
					icon: 'M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'
				}
			]
		}
	];
</script>

<section class="all-features" id="features">
	<div class="container">
		<div class="all-features__header">
			<h2 class="all-features__title">{$_('allFeatures.title')}</h2>
			<p class="all-features__subtitle">{$_('allFeatures.subtitle')}</p>
		</div>

		<div class="all-features__grid">
			{#each groups as group, gi}
				<div class="feature-group" style="--group-index: {gi}">
					<div class="feature-group__header">
						<span class="feature-group__label">{$_(`allFeatures.groups.${group.id}`)}</span>
					</div>
					<ul class="feature-group__list">
						{#each group.features as feature, fi}
							<li class="feature-item" style="--item-index: {gi * 5 + fi}">
								<div class="feature-item__icon">
									<svg
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										stroke-width="1.75"
										stroke-linecap="round"
										stroke-linejoin="round"
									>
										<path d={feature.icon} />
									</svg>
								</div>
								<div class="feature-item__body">
									<span class="feature-item__name"
										>{$_(`allFeatures.items.${feature.id}.title`)}</span
									>
									<span class="feature-item__desc"
										>{$_(`allFeatures.items.${feature.id}.description`)}</span
									>
								</div>
							</li>
						{/each}
					</ul>
				</div>
			{/each}
		</div>
	</div>
</section>

<style>
	.all-features {
		padding-block: var(--section-padding-y);
		background: var(--bg-primary);
		position: relative;
	}

	.all-features::before {
		content: '';
		position: absolute;
		inset: 0;
		background:
			radial-gradient(
				ellipse at 10% 50%,
				hsl(var(--brand-h) var(--brand-s) var(--brand-l) / 0.04) 0%,
				transparent 55%
			),
			radial-gradient(
				ellipse at 90% 50%,
				hsl(var(--secondary-h) var(--secondary-s) var(--secondary-l) / 0.03) 0%,
				transparent 55%
			);
		pointer-events: none;
	}

	.container {
		position: relative;
	}

	.all-features__header {
		text-align: center;
		max-width: 600px;
		margin-inline: auto;
		margin-bottom: var(--space-16);
	}

	.all-features__title {
		margin-bottom: var(--space-4);
		color: var(--text-primary);
		animation: fadeInUp 0.6s ease-out;
	}

	.all-features__subtitle {
		font-size: var(--font-size-lg);
		color: var(--text-secondary);
		line-height: var(--line-height-relaxed);
		animation: fadeInUp 0.6s ease-out 0.1s backwards;
	}

	/* 4-column grid — one column per feature group */
	.all-features__grid {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: var(--space-6);
		align-items: start;
	}

	/* Group column */
	.feature-group {
		background: var(--bg-secondary);
		border: 1px solid var(--border-light);
		border-radius: var(--radius-xl);
		padding: var(--space-6);
		animation: fadeInUp 0.5s ease-out calc(var(--group-index) * 0.08s) backwards;
	}

	.feature-group__header {
		margin-bottom: var(--space-5);
		padding-bottom: var(--space-4);
		border-bottom: 1px solid var(--border-light);
	}

	.feature-group__label {
		font-size: 12px;
		font-weight: 700;
		letter-spacing: 0.08em;
		text-transform: uppercase;
		color: var(--text-brand);
	}

	.feature-group__list {
		list-style: none;
		padding: 0;
		margin: 0;
		display: flex;
		flex-direction: column;
		gap: var(--space-4);
	}

	/* Individual feature row */
	.feature-item {
		display: flex;
		align-items: flex-start;
		gap: var(--space-3);
		animation: fadeInUp 0.4s ease-out calc(var(--item-index) * 0.04s) backwards;
	}

	.feature-item__icon {
		width: 32px;
		height: 32px;
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		background: var(--bg-primary);
		border: 1px solid var(--border-light);
		border-radius: var(--radius-md);
		color: var(--text-brand);
		transition:
			background 0.2s ease,
			border-color 0.2s ease;
	}

	.feature-item__icon svg {
		width: 15px;
		height: 15px;
	}

	.feature-item:hover .feature-item__icon {
		background: hsl(var(--brand-h) var(--brand-s) var(--brand-l) / 0.08);
		border-color: hsl(var(--brand-h) var(--brand-s) var(--brand-l) / 0.2);
	}

	.feature-item__body {
		display: flex;
		flex-direction: column;
		gap: 2px;
		min-width: 0;
	}

	.feature-item__name {
		font-size: var(--font-size-sm);
		font-weight: var(--font-weight-semibold);
		color: var(--text-primary);
		line-height: 1.3;
	}

	.feature-item__desc {
		font-size: 12px;
		color: var(--text-secondary);
		line-height: 1.5;
	}

	@keyframes fadeInUp {
		from {
			opacity: 0;
			transform: translateY(16px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	/* Tablet: 2 columns */
	@media (max-width: 1024px) {
		.all-features__grid {
			grid-template-columns: repeat(2, 1fr);
		}
	}

	/* Mobile: 1 column */
	@media (max-width: 640px) {
		.all-features__grid {
			grid-template-columns: 1fr;
		}

		.all-features__header {
			margin-bottom: var(--space-10);
		}
	}
</style>
